import { render, staticRenderFns } from "./StaticSwiper.vue?vue&type=template&id=4d9734f5&scoped=true&"
import script from "./StaticSwiper.vue?vue&type=script&lang=ts&"
export * from "./StaticSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./StaticSwiper.vue?vue&type=style&index=0&id=4d9734f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9734f5",
  null
  
)

export default component.exports